import { render, staticRenderFns } from "./CacheList.vue?vue&type=template&id=1a5946f6"
import script from "./CacheList.vue?vue&type=script&lang=js"
export * from "./CacheList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports